import { render, staticRenderFns } from "./ButtonReturn.vue?vue&type=template&id=6fa61b68&scoped=true&lang=pug"
import script from "./ButtonReturn.vue?vue&type=script&lang=ts"
export * from "./ButtonReturn.vue?vue&type=script&lang=ts"
import style0 from "./ButtonReturn.vue?vue&type=style&index=0&id=6fa61b68&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa61b68",
  null
  
)

export default component.exports